import React from 'react';

type LogoMarkSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl';

const MARK_SIZES: Record<LogoMarkSize, string> = {
  xs: 'w-6 h-6',
  sm: 'w-7 h-7',
  md: 'w-9 h-9',
  lg: 'w-12 h-12',
  xl: 'w-14 h-14',
};

type BuiltLogoMarkProps = {
  size?: LogoMarkSize;
  className?: string;
};

/** App icon mark — charcoal plate + orange bar + wrench-B (readable on light and dark). */
export const BuiltLogoMark: React.FC<BuiltLogoMarkProps> = ({
  size = 'md',
  className = '',
}) => (
  <img
    src="/brand/app-icon.png"
    alt=""
    aria-hidden
    className={`shrink-0 rounded-xl object-cover shadow-brand ${MARK_SIZES[size]} ${className}`}
    draggable={false}
  />
);
